// extracted by mini-css-extract-plugin
export default {"m":"Approval_m__U2LzH","approval":"Approval_approval__pIz1w"};